import { render, staticRenderFns } from "./emptyRoles.vue?vue&type=template&id=5dd0b98f&scoped=true&"
import script from "./emptyRoles.vue?vue&type=script&lang=js&"
export * from "./emptyRoles.vue?vue&type=script&lang=js&"
import style0 from "./emptyRoles.vue?vue&type=style&index=0&id=5dd0b98f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0b98f",
  null
  
)

export default component.exports